import { observer } from 'mobx-react-lite'
import { IPortVisualComponentProps } from 'react-easy-diagram'

import styles from './port.module.css'

export const Port = observer<IPortVisualComponentProps>(({ entity }) => {
  const className =
    entity.hovered || entity.dragging
      ? `${styles.base} ${styles.hovered}`
      : styles.base

  return <div className={className}></div>
})
